$(document).ready(function() {
  $('body').on('click','.product-card__info .color-swatch',function() {
    // we load the proper images into the first two a hrefs
    var swatch = $(this).text().trim();
    console.log('my alt text is ' + swatch);
    var count = 0;
     var alt = $(this).attr('alt');
     var firstUrl = $(this).parent().parent().parent().find('.media-url-list[alt="'+swatch+'"').eq(0).attr('url');
     var secondUrl = $(this).parent().parent().parent().find('.media-url-list[alt="'+swatch+'"').eq(1).attr('url');
     console.log('my first url is ' + firstUrl);
     console.log('my second url is ' + secondUrl);
    console.log($(this).parent().parent().parent().find('.product-card__image').attr('class'));
    setTimeout(function() {
         $(this).parent().parent().parent().find('.product-card__image').eq(1).attr('src',secondUrl);
    },250)
  });
});